import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Route-aware <meta name="robots"> manager.
 *
 * Auth-gated, transactional and personal pages (dashboards, settings,
 * messages, admin, auth flows, etc.) must never appear in search results.
 * Individual pages can still set their own robots tag via <SEO/>; this acts
 * as a safety net so newly-added private routes are noindex by default.
 *
 * Public pages reset robots to "index,follow" unless they later override it.
 */

const PRIVATE_PREFIXES = [
  "/my-dashboard",
  "/my-reviews",
  "/my-passports",
  "/add-pet",
  "/edit-pet",
  "/pet/",
  "/passport/share",
  "/calendar",
  "/book-appointment",
  "/consultation/",
  "/vet-dashboard",
  "/vet-subscribe",
  "/vet-signup",
  "/admin",
  "/settings",
  "/notifications",
  "/messages",
  "/auth/callback",
  "/mfa",
  "/login",
  "/signup",
  "/forgot-password",
  "/reset-password",
  "/unsubscribe",
  "/confirm-vet-customer",
  "/health",
];

const isPrivate = (pathname: string) =>
  PRIVATE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`) || pathname.startsWith(p));

const RouteRobots = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    let el = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", isPrivate(pathname) ? "noindex,nofollow" : "index,follow");
  }, [pathname]);
  return null;
};

export default RouteRobots;
